export const factories = (state = [], action) => {
  if (action.type === 'FETCH_FACTORIES') {
    return action.payload;
  }
  if (action.type === 'CLEAR_FACTORIES') {
    return [];
  }
  return state;
};

export const factory = (state = {}, action) => {
  if (action.type === 'FETCH_FACTORY') {
    return action.payload;
  }
  if (action.type === 'CLEAR_FACTORY') {
    return {};
  }
  return state;
};

export const factoryIds = (state = [], action) => {
  if (action.type === 'FETCH_FACTORY_IDS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_FACTORY_IDS') {
    return [];
  }
  return state;
};
